import AppConstants from 'constants/AppConstants';

interface State {
  backgroundBase: string;
  brandMuted: string;
  brandPrimary: string;
  font: string;
}

const initialState: State = {
  backgroundBase: '',
  brandMuted: '',
  brandPrimary: '',
  font: '',
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { payload, type } = action;
  switch (type) {
    case AppConstants.SET_COLOR_THEME: {
      return {
        ...payload,
        font: state.font,
      };
    }
    case AppConstants.SET_FONT_THEME: {
      return {
        ...state,
        font: payload.font,
      };
    }
    default:
      return state;
  }
}
